import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";

const initialState: any = {
  refrigeratorList: []
};

const refrigeratorSlice = createSlice({
  name: "refrigerator",
  initialState,
  reducers: {
    setRefrigeratorList: (state, action: PayloadAction<any>) => {
      state.refrigeratorList = action.payload;
    },
  },
});
export const { setRefrigeratorList } = refrigeratorSlice.actions;
export default refrigeratorSlice.reducer;
export const refrigeratorList = (state: RootState) => state.refrigerators.refrigeratorList;
